import { Scene } from 'phaser';

export class PreloadScene extends Scene {
    preload() {
        let progressDisplay = 0;
        let loadCompleted = false;

        let callback = 
            () => {
                let timer = this.time.addEvent({
                    delay: 25,                // ms
                    callback: () => {
                        if(progressDisplay < 1) {
                            if(progressDisplay < this.load.progress || !this.load.progress){
                                progressDisplay+=0.01;
                                
                                GameLoader.setPercentage(Math.round(progressDisplay * 100));
                            }
                        } else {
                            if(!loadCompleted) {
                                return;
                            }
        
                            timer.remove();
        
                            GameLoader.finishLoader(() => {
                                this.scene.start('GameScene');
                            });
                        }
                    },
                    callbackScope: this,
                    loop: true
                });
            };

        GameLoader.initLoader(callback);

        document.getElementById('slots-container').classList.add('loading'); 

        this.load.on('complete', () => {
            loadCompleted = true;
        });

        this.load.path = `/sl/v1/games/${Config.game_name.toLowerCase()}/`;
        for (const [ type, items ] of Object.entries(Config.assets)) {
            for (const [ name, fileName ] of Object.entries(items)) {
                //console.log(`Loading from ${type} name is ${name}...`);
                switch (type) {
                    case 'images':
                        this.load.image(name, fileName);
                        break;
                    case 'sounds':
                        this.load.audio(name, fileName);
                        break;
                    case 'spritesheets':
                        const blocks = fileName.split('_').map(num => parseInt(num));

                        const frameHeight = blocks.pop();
                        const frameWidth = blocks.pop();

                        this.load.spritesheet(name, fileName, { frameWidth, frameHeight });
                        break;
                    case 'fonts':
                        this.load.bitmapFont(name, `${fileName}.png`, `${fileName}.xml`);
                        break;
                    case 'multiatlas':
                        this.load.multiatlas(name, fileName, `${this.load.path}img/`);
                        break;
                    case 'atlas':
                        this.load.atlas(name, `${fileName}.png`, `${fileName}.json`);
                        break;
                }
            }
        }
    }
}